<template>
  <div v-if="!isLoaded">
    <IsLoadingComponent />
  </div>
  <div v-else-if="!hasAccess">
    <div class="info-section">
      <v-icon color="red">mdi-alert-circle-outline</v-icon>
      <div class="info">
        {{ accessMessage }}
      </div>
    </div>
  </div>
  <div v-else>
    <div
      id="uploaderComp"
      :class="{ disableStyle: !isValid }"
      :style="{ display: showUploaderComp ? 'block' : 'none' }"
    ></div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getBoxToken } from '@/service/engagement.js'
import { getWorkfileId } from '@/utils/globalUtil'
import { formatTimestamps } from '@/utils/dateUtils'
import IsLoadingComponent from './IsLoadingComponent.vue'

export default {
  name: 'BoxUploadComponent',
  components: {
    IsLoadingComponent
  },
  props: {
    assignmentData: {
      type: Object,
    },
    subFolder: {
      type: String,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    disableAutoClose: {
      type: Boolean,
      default: true,
    },
    allowedExtensions: {
      type: Array,
    },
  },
  data() {
    return {
      showBoxContainer: false,
      boxObject: [],
      formattedLocalTime: null,
      attributeTime: null,
      showUploaderComp: false,
      isLoaded: false,
      hasAccess: false,
      accessMessage: null,
    }
  },
  methods: {
    ...mapActions({
      add: "notification/add",
    }),
    iterateItems(items, that) {
      items.map((item) => {
        let obj = {
          id: item.id,
          name: item.name,
          size: item.size,
          modified_at: this.attributeTime,
          folderId: 0,
          created_at: item.created_at,
          modified_by: item.modified_by?.login || 'System',
        }
        return that.boxObject.push(obj)
      })
      that.$emit('boxObject', that.boxObject)
    },
    setTimestamps(date = new Date()) {
      const { attributeTime, formattedLocalTime } = formatTimestamps(date)
      this.attributeTime = attributeTime
      this.formattedLocalTime = formattedLocalTime
    },
    requestIntercept(request) {
      this.$emit('processing', true)
      this.setTimestamps()
      if (request.method == 'post') {
        if (
          request.data.attributes &&
          typeof request.data.attributes == 'string'
        ) {
          let attributes = JSON.parse(request.data.attributes)
          let ext = attributes.name.lastIndexOf('.')
          let updatedName =
            attributes.name.slice(0, ext) +
            '_' +
            this.formattedLocalTime +
            attributes.name.slice(ext)
          attributes.name = updatedName
          attributes.content_modified_at = this.attributeTime
          request.data.attributes = JSON.stringify(attributes)
        }
        if (request.data.file_name) {
          let ext = request.data.file_name.lastIndexOf('.')
          let updatedFileName =
            request.data.file_name.slice(0, ext) +
            this.formattedLocalTime +
            request.data.file_name.slice(ext)
          request.data.file_name = updatedFileName
        }
      }
      if (request.method == 'options') {
        if (request.data.name) {
          let ext = request.data.name.lastIndexOf('.')
          let updatedName =
            request.data.name.slice(0, ext) +
            this.formattedLocalTime +
            request.data.name.slice(ext)
          request.data.name = updatedName
        }
      }
      return request
    },
    async openBox() {
      try {
        let workfile = this.assignmentData?.workFileLink
        let folderId = getWorkfileId(workfile)
        let boxTokenObject = await getBoxToken(folderId)
        this.isLoaded = true

        if (boxTokenObject == null || !boxTokenObject.hasUserAccount) {
          this.showBoxContainer = false
          let notification = {
            type: 'error',
            message: 'You do not have access to Box.',
          }
          // this.add(notification)
          this.hasAccess = false
          this.accessMessage = notification.message
        } else if (!boxTokenObject.hasFolderAccess) {
          this.showBoxContainer = false
          let notification = {
            type: 'error',
            message: 'You do not have access to this Box folder.',
          }
          // this.add(notification)
          this.hasAccess = false
          this.accessMessage = notification.message
        } else {
          this.hasAccess = true
          this.accessMessage = null
          this.showBoxContainer = true
          const that = this
          let boxToken = boxTokenObject.token
          let uploader = new Box.ContentUploader()
          this.$nextTick(() => {
            uploader.show(this.subFolder, boxToken, {
              container: '#uploaderComp',
              requestInterceptor: this.requestIntercept,
            })
          })
          uploader.addListener('complete', function (items) {
            that.iterateItems(items, that)
            that.$emit('processing', false)
            if (!that.disableAutoClose) {
              that.$emit('closeModal')
            }
          })
          uploader.addListener('close', function () {
            that.$emit('processing', false)
            that.$emit('closeModal')
          })
          uploader.addListener('cancel', function () {
            that.$emit('processing', false)
          })
          uploader.addListener('error', function () {
            that.$emit('processing', false)
          })
        }
      } catch (error) {
        console.error('Error opening Box uploader:', error)
        let notification = {
          type: 'error',
          message: 'Failed to load Box uploader',
        }
        // this.add(notification)
        this.isLoaded = true
        this.accessMessage = notification.message
        this.hasAccess = false
      }
    },
  },
  mounted() {
    this.openBox()
    const that = this
    setTimeout(() => {
      const boxContainer = document.getElementById('uploaderComp')
      if (boxContainer) {
        const fileInput = boxContainer.querySelector('input[type="file"]')
        if (fileInput) {
          const allowedFileExtensions = that.allowedExtensions
            ? that.allowedExtensions.join(',')
            : ''
          fileInput.setAttribute('accept', allowedFileExtensions)
        }
      }
      that.showUploaderComp = true
    }, 2000)
  },
}
</script>
<style scoped>
.info-section {
  display: flex;
  align-items: center;
  margin-left: 12px;
  margin-right: 12px;
  background-color: #ffe7e7;
  padding: 24px;
  border-radius: 4px;
  margin-bottom: 4px;
  border: 1px solid #b92424a6;
}

.info-section .info {
  margin-left: 8px;
  font-size: 14px;
}

.disableStyle {
  pointer-events: none;
  opacity: 0.6;
}

/* Box uploader button alignment fixes */
#uploaderComp :deep(.be-modal-dialog-footer) {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  overflow-x: auto !important;
  flex-wrap: nowrap !important;
  min-width: 0 !important;
  width: 100% !important;
  min-width: 250px !important;
}
#uploaderComp :deep(.bcu-footer) {
  overflow: auto !important;
}
#uploaderComp :deep(.bcu-footer-right) {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 6px !important;
  padding: 8px 12px !important;
  flex-wrap: nowrap !important;
  min-width: 0 !important;
  width: 100% !important;
  min-width: 250px !important;
}
#uploaderComp :deep(.be-btn) {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 28px !important;
  padding: 4px 12px !important;
  border-radius: 3px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  margin: 0 !important;
  vertical-align: middle !important;
  flex-shrink: 0 !important;
  white-space: nowrap !important;
  min-width: 60px !important;
}

#uploaderComp :deep(.be-btn-primary) {
  background-color: #0061d5 !important;
  color: white !important;
  border: 1px solid #0061d5 !important;
}

#uploaderComp :deep(.be-btn-primary:hover) {
  background-color: #004c99 !important;
  border-color: #004c99 !important;
}

#uploaderComp :deep(.be-btn-secondary) {
  background-color: transparent !important;
  color: #666 !important;
  border: 1px solid #ddd !important;
}

#uploaderComp :deep(.be-btn-secondary:hover) {
  background-color: #f5f5f5 !important;
  border-color: #bbb !important;
}

/* Fix button container alignment */
#uploaderComp :deep(.be-modal-dialog) {
  display: flex !important;
  flex-direction: column !important;
  max-height: 90vh !important;
  max-width: 95vw !important;
  overflow: hidden !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

#uploaderComp :deep(.be-modal-dialog-body) {
  flex: 1 !important;
  padding: 16px !important;
  overflow-y: auto !important;
  max-height: calc(90vh - 120px) !important;
}


#uploaderComp :deep(.be-footer) {
  display: flex !important;
  background-color: red !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 6px !important;
  padding: 8px 12px !important;
}
/* Fix the modal backdrop and container */
#uploaderComp :deep(.be-modal) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 9999 !important;
  padding: 20px !important;
  box-sizing: border-box !important;
}


</style>